'use strict';

Object.defineProperty(exports, "__esModule", {
	value: true
});

var _createReviewModal = require('../actions/create-review-modal');

var VALIDATE_REVIEW_CODE_RECEIVED = _createReviewModal.VALIDATE_REVIEW_CODE + '_RECEIVED';

var VALIDATE_REVIEW_CODE_FAILED = _createReviewModal.VALIDATE_REVIEW_CODE + '_FAILED';
var POST_REVIEW_RECEIVED = _createReviewModal.POST_REVIEW + '_RECEIVED';

var createReviewModal = function createReviewModal(state, action) {
	switch (action.type) {
		case _createReviewModal.OPEN:
			return Object.assign({}, state, { isOpen: true });
		case _createReviewModal.CLOSE:
			return Object.assign({}, state, { isOpen: false });
		case _createReviewModal.RESET:
			return { stage: 1, isOpen: false };
		case VALIDATE_REVIEW_CODE_RECEIVED:
			{
				var profileToReview = action.response.specialist || action.response.practice;
				profileToReview.type = action.response.specialist ? 'specialist' : 'practice';
				return Object.assign({}, state, { isReviewCodeValid: true, stage: 2, profileToReview: profileToReview });
			}
		case VALIDATE_REVIEW_CODE_FAILED:
			return Object.assign({}, state, { profileToReview: null, isReviewCodeValid: false, stage: 1 });
		case _createReviewModal.CHANGE_RATING:
			return Object.assign({}, state, { rating: action.rating, tentativeRating: 0 });
		case _createReviewModal.CHANGE_REVIEW_CODE:
			return Object.assign({}, state, { code: action.code });
		case _createReviewModal.CHANGE_TENTATIVE_RATING:
			return Object.assign({}, state, { tentativeRating: action.tentativeRating });
		case POST_REVIEW_RECEIVED:
			return Object.assign({}, state, { reviewSubmitted: true, stage: 3 });
		case _createReviewModal.CHANGE_REVIEW_BODY:
			return Object.assign({}, state, { reviewBody: action.body });
		case _createReviewModal.CHANGE_REVIEW_STAGE:
			return Object.assign({}, state, { stage: action.stage });
		case _createReviewModal.CHANGE_REVIEW_CERTIFICATION:
			return Object.assign({}, state, { reviewCertified: action.isCertified });
		default:
			return state || { stage: 1, isOpen: false };
	}
};

exports.default = createReviewModal;


//////////////////
// WEBPACK FOOTER
// ./node_modules/doctify-global-redux/lib/reducers/create-review-modal.js
// module id = 1680
// module chunks = 0